<template>
  <div class="swatch-list-wrapper">
    <ul class="swatch-list" :class="{'swatch-list--hidden': isHidden }">
      <li :class="optionClass(option.Id)" v-for="(option, index) in options" :key="index">
        <button @click="selectOption(option)" class="swatch-list__btn">
          <div class="swatch-list__btn-img-wrapper">
            <img
              class="swatch-list__btn-img"
              :src="option.Images.Thumbnail.Filename"
              :alt="option.Name"
            >
          </div>
          <span class="swatch-list__name">{{option.Name}}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import store from "../../store";

export default {
  name: "swatch-list",
  data() {
    return {
      isHidden: false
    };
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    option: {
      type: String,
      validator: function(value) {
        return (
          ["Fabric", "Caps", "Icon", "Spine", "Loop"].indexOf(value) !== -1
        );
      }
    }
  },
  mounted() {
    // if there is a selection, scroll it into the viewport
    const that = this;
    let selected = document.querySelector(".swatch-list__item--active");
    if (selected) {
      selected.scrollIntoView();
    } else {
      console.log("mounted", that.hidden);
      that.isHidden = true;
      setTimeout(function() {
        console.log("hi");
        that.isHidden = false;
      }, 200);
    }
  },
  computed: {},
  methods: {
    selectOption(option) {
      if (store.state.configuration[this.option] === option.Id) {
        // deselect it
        store.commit("selectOption", {
          CategoryName: this.option,
          Id: null
        });
      } else {
        store.commit("selectOption", option);
      }
    },
    optionClass(id) {
      let selectedId = store.state.configuration[this.option];
      if (typeof selectedId === "undefined" || selectedId === null) {
        return "swatch-list__item";
      } else {
        if (selectedId === id) {
          return "swatch-list__item swatch-list__item--active";
        } else {
          return "swatch-list__item swatch-list__item--inactive";
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../scss/variables";
.swatch-list-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  padding-top: 1.5em;
  padding-bottom: 1.5em;
  box-sizing: border-box;

  @media (min-width: 1250px) {
    overflow: visible;
  }
}
.swatch-list {
  list-style: none outside;
  margin: 0;
  padding: 0 1em;
  white-space: nowrap;
  text-align: center;
  transform: translateY(0);
  opacity: 1;
  transition: transform 0.2s, opacity 0.2s;

  &--hidden {
    opacity: 0;
    transform: translateY(20px);
  }

  @media (min-width: 1250px) {
    display: flex;
    justify-content: center;
    white-space: normal;
  }

  &__btn-img-wrapper {
    &:after {
      content: "";
      background: transparent url("/images/checkmark.png") center center
        no-repeat;
      background-size: 20px auto;
      width: 30px;
      height: 30px;
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      opacity: 0;
      transition: opacity 0.25s;
    }
  }

  &__item {
    //max-width: 90px;
    // min-width: 66px;
    min-width: 21vw;
    white-space: normal;
    //margin-right: 1rem;
    display: inline-block;
    @media (min-width: 400px) {
      min-width: 14.75vw;
    }
    @media (min-width: 550px) {
      min-width: 13vw;
    }

    @media (min-width: 650px) {
      min-width: 11.5vw;
    }
    @media (min-width: 992px) {
      min-width: 80px;
      margin-right: 1em;
    }
    &:last-child {
      margin-right: 0;
    }
    &--active {
      .swatch-list__name {
        color: #000;
      }
      .swatch-list__btn-img-wrapper {
        position: relative;
        &:after {
          opacity: 1;
        }
      }
    }
    &--inactive {
      .swatch-list__btn-img {
        opacity: 0.5;
        transform: scale(0.75);
      }
    }
  }
  &__btn {
    background: transparent none;
    padding: 0;
    border: none;
    cursor: pointer;
    font-weight: bold;
    font-size: 11px;
    font-size: 0.7em;
    &:focus {
      outline: none;
      .swatch-list__name {
        color: #000;
        opacity: 1;
      }
    }
    @media (min-width: 992px) {
      transition: opacity 0.25s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  &__btn-img {
    border-radius: 100%;
    max-width: 50px;
    transition: opacity 0.25s, transform 0.25s;
    margin-left: auto;
    margin-right: auto;
  }
  &__name {
    display: none;
    @media (min-width: 992px) {
      display: block;
      margin-top: 0.5em;
      line-height: 1;
      height: 2em;
      text-align: center;
      hyphens: auto;
      text-transform: uppercase;
      color: $greyMidDark;
      font-family: $font;
    }
  }
}
</style>
